import { render, staticRenderFns } from "./PasswordReset.vue?vue&type=template&id=c61c0bd4&scoped=true"
import script from "./PasswordReset.vue?vue&type=script&lang=js"
export * from "./PasswordReset.vue?vue&type=script&lang=js"
import style0 from "./PasswordReset.vue?vue&type=style&index=0&id=c61c0bd4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c61c0bd4",
  null
  
)

export default component.exports